var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M20 0H0V20H20V0Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87648 16.1235C0.140924 12.388 -0.187776 6.92485 3.06915 2.76633L3.28415 2.5L6.7711 5.98695L6.65834 6.14683C5.0705 8.47367 5.64056 11.0194 7.31057 12.6894C8.96151 14.3403 11.4682 14.9163 13.7733 13.3953L14.0131 13.2289L17.5 16.7158L17.18 16.9724L17.1246 17.0153C12.98 20.1818 7.57945 19.8265 3.87648 16.1235Z",
    fill: "url(#paint0_linear_4_30)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0453 8.98545L18.1089 1.92181",
    stroke: "#5CD4D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9348 8.98458H11.0471V3.09692",
    stroke: "#5CD4D5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_30",
    x1: -5.32579,
    y1: 11.9926,
    x2: 10.0652,
    y2: 26.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36CDCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/Incoming.ca93db93cc82e0c833c889ce1487d938.svg";
export { ForwardRef as ReactComponent };